import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Rooms from "../components/Rooms";
import RestaurantBar from "../components/RestaurantBar";
import NearbyDestinations from "../components/NearbyDestinations";
import Facilities from "../components/Facilities";
import Gallery from "../components/Gallery";
import Offers from "../components/Offers";
import Reviews from "../components/Reviews";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import FloatingWhatsApp from "../components/FloatingWhatsApp";
import MusicToggle from "../components/MusicToggle";
import SplashScreen from "../components/SplashScreen";
import SideDots from "../components/SideDots";
import { siteConfig } from "../config/siteConfig";

export default function HomePage() {
  const [showSplash, setShowSplash] = useState(() => {
    if (!siteConfig.features.showSplash) return false;
    try {
      return !sessionStorage.getItem("thuruliya_splash_seen");
    } catch {
      return true;
    }
  });

  useEffect(() => {
    document.title = "Thuruliya Heritage Anuradhapura";

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll(".reveal").forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [showSplash]);

  useEffect(() => {
    if (showSplash) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [showSplash]);

  const onSplashDone = () => {
    try {
      sessionStorage.setItem("thuruliya_splash_seen", "1");
    } catch {
      /* ignore */
    }
    setShowSplash(false);
  };

  const f = siteConfig.features;

  return (
    <div data-testid="homepage-root" className="bg-[#FAF9F6] text-[#2C2C2C]">
      {showSplash && <SplashScreen onComplete={onSplashDone} />}
      <Navbar />
      <Hero />
      <About />
      {f.showRooms && <Rooms />}
      {f.showRestaurantBar && <RestaurantBar />}
      {f.showNearby && <NearbyDestinations />}
      {f.showFacilities && <Facilities />}
      {f.showGallery && <Gallery />}
      {f.showOffers && <Offers />}
      {f.showReviews && <Reviews />}
      <Contact />
      <Footer />
      <FloatingWhatsApp />
      <MusicToggle />
      <SideDots />
    </div>
  );
}
